import { render, staticRenderFns } from "./TableIndex.vue?vue&type=template&id=ce6f42e0&"
import script from "./TableIndex.vue?vue&type=script&lang=ts&"
export * from "./TableIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports